/* =========================================================
   Mind — Trade-In Modal

   Multi-step estimator. Brands / phones / conditions / settings
   are fetched from the Cloudflare Worker at:

     window.MindTradeIn.workerUrl
       or
     <html data-trade-in-worker="…">

   If the worker is unreachable, we fall back to the embedded
   snapshot below so the modal still renders.
   ========================================================= */

(function () {
  'use strict';

  // ---------- Worker config ----------
  function workerUrl() {
    return (
      (window.MindTradeIn && window.MindTradeIn.workerUrl) ||
      document.documentElement.getAttribute('data-trade-in-worker') ||
      ''
    ).replace(/\/+$/, '');
  }

  // ---------- Embedded data (fallback only; live data comes from the worker) ----------
  const DATA = {
    brands: [
      'Apple', 'Samsung', 'Google', 'OnePlus', 'Motorola',
      'LG', 'Sony', 'Other',
    ],
    phones: [
      { brand: 'Apple', model: 'iPhone 15 Pro Max', base: 650 },
      { brand: 'Apple', model: 'iPhone 15 Pro', base: 580 },
      { brand: 'Apple', model: 'iPhone 15 Plus', base: 480 },
      { brand: 'Apple', model: 'iPhone 15', base: 420 },
      { brand: 'Apple', model: 'iPhone 14 Pro Max', base: 500 },
      { brand: 'Apple', model: 'iPhone 14 Pro', base: 450 },
      { brand: 'Apple', model: 'iPhone 14 Plus', base: 380 },
      { brand: 'Apple', model: 'iPhone 14', base: 350 },
      { brand: 'Apple', model: 'iPhone 13 Pro Max', base: 400 },
      { brand: 'Apple', model: 'iPhone 13 Pro', base: 350 },
      { brand: 'Apple', model: 'iPhone 13', base: 280 },
      { brand: 'Apple', model: 'iPhone 13 Mini', base: 220 },
      { brand: 'Apple', model: 'iPhone 12 Pro Max', base: 300 },
      { brand: 'Apple', model: 'iPhone 12 Pro', base: 260 },
      { brand: 'Apple', model: 'iPhone 12', base: 200 },
      { brand: 'Apple', model: 'iPhone 12 Mini', base: 150 },
      { brand: 'Apple', model: 'iPhone 11 Pro Max', base: 200 },
      { brand: 'Apple', model: 'iPhone 11 Pro', base: 180 },
      { brand: 'Apple', model: 'iPhone 11', base: 140 },
      { brand: 'Apple', model: 'iPhone SE (3rd Gen)', base: 120 },
      { brand: 'Apple', model: 'iPhone SE (2nd Gen)', base: 80 },
      { brand: 'Samsung', model: 'Galaxy S24 Ultra', base: 550 },
      { brand: 'Samsung', model: 'Galaxy S24+', base: 450 },
      { brand: 'Samsung', model: 'Galaxy S24', base: 380 },
      { brand: 'Samsung', model: 'Galaxy S23 Ultra', base: 420 },
      { brand: 'Samsung', model: 'Galaxy S23+', base: 350 },
      { brand: 'Samsung', model: 'Galaxy S23', base: 300 },
      { brand: 'Samsung', model: 'Galaxy S22 Ultra', base: 320 },
      { brand: 'Samsung', model: 'Galaxy S22+', base: 260 },
      { brand: 'Samsung', model: 'Galaxy S22', base: 220 },
      { brand: 'Samsung', model: 'Galaxy S21 Ultra', base: 250 },
      { brand: 'Samsung', model: 'Galaxy S21+', base: 200 },
      { brand: 'Samsung', model: 'Galaxy S21', base: 170 },
      { brand: 'Samsung', model: 'Galaxy Z Fold 5', base: 600 },
      { brand: 'Samsung', model: 'Galaxy Z Fold 4', base: 450 },
      { brand: 'Samsung', model: 'Galaxy Z Flip 5', base: 400 },
      { brand: 'Samsung', model: 'Galaxy Z Flip 4', base: 300 },
      { brand: 'Samsung', model: 'Galaxy A54', base: 150 },
      { brand: 'Samsung', model: 'Galaxy A53', base: 120 },
      { brand: 'Google', model: 'Pixel 8 Pro', base: 400 },
      { brand: 'Google', model: 'Pixel 8', base: 320 },
      { brand: 'Google', model: 'Pixel 7 Pro', base: 280 },
      { brand: 'Google', model: 'Pixel 7', base: 220 },
      { brand: 'Google', model: 'Pixel 7a', base: 180 },
      { brand: 'Google', model: 'Pixel 6 Pro', base: 200 },
      { brand: 'Google', model: 'Pixel 6', base: 150 },
      { brand: 'Google', model: 'Pixel 6a', base: 120 },
      { brand: 'OnePlus', model: '12', base: 350 },
      { brand: 'OnePlus', model: '11', base: 280 },
      { brand: 'OnePlus', model: '10 Pro', base: 220 },
      { brand: 'OnePlus', model: '10T', base: 180 },
      { brand: 'OnePlus', model: '9 Pro', base: 150 },
      { brand: 'OnePlus', model: '9', base: 120 },
      { brand: 'Motorola', model: 'Edge+ (2023)', base: 200 },
      { brand: 'Motorola', model: 'Edge (2023)', base: 150 },
      { brand: 'Motorola', model: 'Razr+ (2023)', base: 350 },
      { brand: 'Motorola', model: 'Razr (2023)', base: 250 },
      { brand: 'LG', model: 'Wing', base: 100 },
      { brand: 'LG', model: 'Velvet', base: 80 },
      { brand: 'LG', model: 'V60 ThinQ', base: 90 },
      { brand: 'Sony', model: 'Xperia 1 V', base: 400 },
      { brand: 'Sony', model: 'Xperia 5 V', base: 300 },
      { brand: 'Sony', model: 'Xperia 1 IV', base: 280 },
      { brand: 'Sony', model: 'Xperia 5 IV', base: 200 },
    ],
    conditions: [
      { name: 'Excellent', modifier: 100, desc: 'Like new — no scratches or damage. Fully functional.' },
      { name: 'Good',      modifier: 80,  desc: 'Minor cosmetic wear — light scratches. Fully functional.' },
      { name: 'Fair',      modifier: 60,  desc: 'Moderate wear — visible scratches or small dents.' },
      { name: 'Poor',      modifier: 40,  desc: 'Heavy wear — cracked screen or damage. Still works.' },
    ],
    settings: {
      otherOffer: 50,
      returnDays: 14,
      // The PDP base price, used to cap trade-in value visually.
      basePrice: 342,
    },
  };

  // ---------- State ----------
  const state = {
    step: 1,
    brand: null,
    model: null,
    modelBase: 0,
    condition: null,
    conditionMod: 0,
    value: 0,
  };

  // ---------- Helpers ----------
  const $  = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const esc = (txt) => {
    const div = document.createElement('div');
    div.textContent = txt;
    return div.innerHTML;
  };
  const fmt = (n) => `$${Math.max(0, Math.round(n)).toLocaleString()}`;

  // ---------- DOM refs (populated after modal is built) ----------
  let el = {};

  // ---------- Build modal markup ----------
  function buildModal() {
    const wrap = document.createElement('div');
    wrap.className = 'ti-overlay';
    wrap.id = 'ti-overlay';
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'true');
    wrap.setAttribute('aria-labelledby', 'ti-title');
    wrap.hidden = true;

    wrap.innerHTML = `
      <div class="ti-modal">
        <button type="button" class="ti-close" id="ti-close" aria-label="Close trade-in">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>

        <header class="ti-header">
          <p class="ti-eyebrow" id="ti-title">Trade In</p>
          <div class="ti-dots" role="progressbar" aria-valuemin="1" aria-valuemax="4" aria-valuenow="1">
            <span class="ti-dot active" data-dot="1"></span>
            <span class="ti-dot"        data-dot="2"></span>
            <span class="ti-dot"        data-dot="3"></span>
            <span class="ti-dot"        data-dot="4"></span>
          </div>
        </header>

        <div class="ti-content">
          <!-- Step 1 -->
          <section class="ti-step is-active" data-step="1">
            <h3 class="ti-step-title">What brand is your current phone?</h3>
            <div class="ti-options" id="ti-brand-opts"></div>
          </section>

          <!-- Step 2 -->
          <section class="ti-step" data-step="2">
            <button type="button" class="ti-back" data-back="1">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5"/><path d="M12 19l-7-7 7-7"/></svg>
              Back to brands
            </button>
            <h3 class="ti-step-title">Which model?</h3>
            <div class="ti-selected">
              <span>Brand:</span>
              <span id="ti-sel-brand"></span>
            </div>
            <div class="ti-options ti-options--scroll" id="ti-model-opts"></div>
          </section>

          <!-- Step 3 -->
          <section class="ti-step" data-step="3">
            <button type="button" class="ti-back" data-back="2">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5"/><path d="M12 19l-7-7 7-7"/></svg>
              Back to models
            </button>
            <h3 class="ti-step-title">What condition is it in?</h3>
            <div class="ti-selected">
              <span>Phone:</span>
              <span id="ti-sel-model"></span>
            </div>
            <div class="ti-options" id="ti-cond-opts"></div>
          </section>

          <!-- Step 4 -->
          <section class="ti-step" data-step="4">
            <button type="button" class="ti-back" data-back="3">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5"/><path d="M12 19l-7-7 7-7"/></svg>
              Back to condition
            </button>
            <h3 class="ti-step-title">Your trade-in estimate</h3>

            <div class="ti-summary">
              <div class="ti-summary-row"><span class="ti-summary-label">Brand</span>    <span class="ti-summary-value" id="ti-sum-brand"></span></div>
              <div class="ti-summary-row"><span class="ti-summary-label">Model</span>    <span class="ti-summary-value" id="ti-sum-model"></span></div>
              <div class="ti-summary-row"><span class="ti-summary-label">Condition</span><span class="ti-summary-value" id="ti-sum-cond"></span></div>
              <div class="ti-summary-row ti-summary-total">
                <span class="ti-summary-label">Trade-in credit</span>
                <span class="ti-summary-value" id="ti-sum-value">$0</span>
              </div>
            </div>

            <div class="ti-price-preview">
              <span class="ti-price-preview-label">Your price</span>
              <span>
                <span class="ti-price-preview-value" id="ti-price-new">$0</span>
                <span class="ti-price-preview-was" id="ti-price-was">$0</span>
              </span>
            </div>

            <div class="ti-notice">
              <span class="ti-notice-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
              </span>
              <p class="ti-notice-text">
                This is a pre-order. Once your Phone 2 Pro ships, we'll email a prepaid return label — you'll have 14 days from delivery to send in your trade-in device.
              </p>
            </div>

            <div class="ti-terms">
              <label class="ti-terms-label">
                <input type="checkbox" class="ti-terms-input" id="ti-terms">
                <span class="ti-terms-box"></span>
                <span class="ti-terms-text">
                  I agree to send my trade-in device within 14 days of delivery. Final credit is contingent on the device matching the condition selected.
                </span>
              </label>
            </div>

            <button type="button" class="ti-confirm" id="ti-confirm" disabled>
              Apply trade-in credit
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="M12 5l7 7-7 7"/></svg>
            </button>
          </section>

        </div>
      </div>
    `;

    document.body.appendChild(wrap);
    return wrap;
  }

  // ---------- Rendering ----------
  function renderBrands() {
    const html = DATA.brands.map((b) => `
      <button type="button" class="ti-option" data-brand="${esc(b)}">
        <span>${esc(b)}</span>
        <span class="ti-option-chevron">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>
        </span>
      </button>
    `).join('');
    el.brandOpts.innerHTML = html;
    $$('.ti-option', el.brandOpts).forEach((btn) => {
      btn.addEventListener('click', () => selectBrand(btn.dataset.brand));
    });
  }

  function renderModels(brand) {
    const models = DATA.phones.filter((p) => p.brand === brand);
    if (!models.length) {
      el.modelOpts.innerHTML = `
        <div class="ti-option" style="cursor:default;flex-direction:column;align-items:flex-start;gap:8px;">
          <strong>No listed models for ${esc(brand)}.</strong>
          <button type="button" class="ti-back" style="margin:0;padding:4px 0;" id="ti-jump-other">Use "Other" instead →</button>
        </div>
      `;
      $('#ti-jump-other')?.addEventListener('click', () => selectBrand('Other'));
      return;
    }
    el.modelOpts.innerHTML = models.map((p) => `
      <button type="button" class="ti-option" data-model="${esc(p.model)}" data-base="${p.base}">
        <span>${esc(p.model)}</span>
        <span class="ti-option-value">$${p.base}</span>
      </button>
    `).join('');
    $$('.ti-option', el.modelOpts).forEach((btn) => {
      btn.addEventListener('click', () => {
        selectModel(btn.dataset.model, parseFloat(btn.dataset.base));
      });
    });
  }

  function renderConditions() {
    el.condOpts.innerHTML = DATA.conditions.map((c) => `
      <button type="button" class="ti-option ti-option--cond" data-cond="${esc(c.name)}" data-mod="${c.modifier}">
        <span class="ti-option-row">
          <span class="ti-option-name">${esc(c.name)}</span>
          <span class="ti-option-mod">${c.modifier}% of value</span>
        </span>
        <span class="ti-option-desc">${esc(c.desc)}</span>
      </button>
    `).join('');
    $$('.ti-option', el.condOpts).forEach((btn) => {
      btn.addEventListener('click', () => {
        selectCondition(btn.dataset.cond, parseFloat(btn.dataset.mod));
      });
    });
  }

  // ---------- Flow ----------
  function selectBrand(brand) {
    state.brand = brand;
    el.selBrand.textContent = brand;
    $$('.ti-option', el.brandOpts).forEach((b) => {
      b.classList.toggle('is-selected', b.dataset.brand === brand);
    });

    if (brand === 'Other') {
      state.model = 'Other device';
      state.modelBase = DATA.settings.otherOffer;
      el.selModel.textContent = state.model;
      renderConditions();
      goToStep(3);
    } else {
      renderModels(brand);
      goToStep(2);
    }
  }

  function selectModel(model, base) {
    state.model = model;
    state.modelBase = base;
    el.selModel.textContent = `${state.brand} ${model}`;
    $$('.ti-option', el.modelOpts).forEach((b) => {
      b.classList.toggle('is-selected', b.dataset.model === model);
    });
    renderConditions();
    goToStep(3);
  }

  function selectCondition(name, modifier) {
    state.condition = name;
    state.conditionMod = modifier;
    $$('.ti-option', el.condOpts).forEach((b) => {
      b.classList.toggle('is-selected', b.dataset.cond === name);
    });

    // Calculate (cap at base phone price so "your price" never goes negative visually)
    const raw = state.modelBase * (modifier / 100);
    state.value = Math.min(Math.round(raw), DATA.settings.basePrice);

    // Fill summary
    el.sumBrand.textContent = state.brand;
    el.sumModel.textContent = state.model;
    el.sumCond.textContent  = state.condition;
    el.sumValue.textContent = fmt(state.value);

    const newPrice = Math.max(0, DATA.settings.basePrice - state.value);
    el.priceNew.textContent = fmt(newPrice);
    el.priceWas.textContent = fmt(DATA.settings.basePrice);

    // Reflect the new total on the confirm CTA
    updateConfirmLabel(newPrice);

    goToStep(4);
  }

  function updateConfirmLabel(newPrice) {
    const lbl = el.confirm?.querySelector('.ti-confirm-label');
    const text = `Confirm & add to cart — ${fmt(newPrice)}`;
    if (lbl) lbl.textContent = text;
    else if (el.confirm) {
      // First time — seed the span so future updates are cheap
      const arrow = el.confirm.querySelector('svg');
      el.confirm.textContent = '';
      const span = document.createElement('span');
      span.className = 'ti-confirm-label';
      span.textContent = text;
      el.confirm.appendChild(span);
      if (arrow) el.confirm.appendChild(arrow);
      else {
        const s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        s.setAttribute('width', '16'); s.setAttribute('height', '16');
        s.setAttribute('viewBox', '0 0 24 24'); s.setAttribute('fill', 'none');
        s.setAttribute('stroke', 'currentColor'); s.setAttribute('stroke-width', '2');
        s.setAttribute('stroke-linecap', 'round'); s.setAttribute('stroke-linejoin', 'round');
        s.innerHTML = '<path d="M5 12h14"/><path d="M12 5l7 7-7 7"/>';
        el.confirm.appendChild(s);
      }
    }
  }

  function goToStep(n) {
    state.step = n;
    $$('.ti-step', el.modal).forEach((s) => {
      const match = s.dataset.step === String(n);
      s.classList.toggle('is-active', match);
    });
    $$('.ti-dot', el.modal).forEach((d) => {
      const i = parseInt(d.dataset.dot, 10);
      d.classList.toggle('active', i === n);
      d.classList.toggle('done',   i <  n);
    });
    const bar = $('.ti-dots', el.modal);
    if (bar && typeof n === 'number') bar.setAttribute('aria-valuenow', n);
    // Scroll content to top on step change
    const content = $('.ti-content', el.modal);
    if (content) content.scrollTop = 0;
  }

  function reset() {
    state.step = 1;
    state.brand = null;
    state.model = null;
    state.modelBase = 0;
    state.condition = null;
    state.conditionMod = 0;
    state.value = 0;
    if (el.terms)   el.terms.checked = false;
    if (el.confirm) el.confirm.disabled = true;
    goToStep(1);
  }

  // ---------- Open / close ----------
  function syncBasePrice() {
    const btn = document.getElementById('tradeInBtn');
    const fromAttr = btn && parseFloat(btn.dataset.tradeinBasePrice);
    if (fromAttr && !Number.isNaN(fromAttr) && fromAttr > 0) {
      DATA.settings.basePrice = Math.round(fromAttr);
    }
  }
  function open() {
    syncBasePrice();
    el.overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    reset();
    // Seed the confirm label with the full price in case the user hasn't picked yet
    updateConfirmLabel(DATA.settings.basePrice);
    // Focus the modal for a11y
    setTimeout(() => $('.ti-modal', el.overlay)?.focus?.(), 20);
  }

  function close() {
    el.overlay.hidden = true;
    document.body.style.overflow = '';
  }

  // ---------- Cart + discount helpers ----------
  function resolveProductInfo() {
    const btn = document.getElementById('tradeInBtn');
    const hiddenVariant = document.getElementById('variant-id');
    return {
      productId:
        (btn && btn.dataset.tradeinProductId) ||
        document.documentElement.getAttribute('data-tradein-product-id') ||
        null,
      variantId:
        (btn && btn.dataset.tradeinVariantId) ||
        (hiddenVariant ? hiddenVariant.value : null) ||
        document.documentElement.getAttribute('data-tradein-variant-id') ||
        null,
    };
  }

  async function addToCart(variantId, props) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1, properties: props }] }),
    });
    if (!res.ok) {
      let detail = '';
      try { detail = (await res.json()).description || ''; } catch (_) {}
      throw new Error(detail || 'Could not add to cart.');
    }
    return res.json();
  }

  async function applyDiscountCookie(code) {
    try {
      await fetch('/discount/' + encodeURIComponent(code), {
        method: 'GET',
        credentials: 'same-origin',
        redirect: 'manual',
      });
    } catch (_) { /* non-fatal: cookie still likely set */ }
  }

  function renderDrawerBanner(info) {
    const foot = document.querySelector('[data-cart-drawer-foot]');
    if (!foot) return;
    foot.querySelectorAll('[data-tradein-banner]').forEach((n) => n.remove());
    const banner = document.createElement('div');
    banner.className = 'cart-drawer__preorder';
    banner.setAttribute('data-tradein-banner', '');
    banner.innerHTML = `
      <div class="cart-drawer__preorder-row">
        <span class="cart-drawer__preorder-badge">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>
          Trade-in credit applied
        </span>
        <strong class="cart-drawer__preorder-value">&minus; ${fmt(info.credit)}</strong>
      </div>
      <div class="cart-drawer__preorder-meta">
        <span class="cart-drawer__preorder-code">Code: <code>${esc(info.code)}</code></span>
        <span class="cart-drawer__preorder-case">${esc(info.brand)} ${esc(info.model)} · ${esc(info.condition)}</span>
      </div>
    `;
    foot.insertBefore(banner, foot.firstChild);
    const checkout = foot.querySelector('.cart-drawer__checkout');
    if (checkout) {
      checkout.setAttribute('href', '/discount/' + encodeURIComponent(info.code) + '?redirect=/checkout');
    }
  }

  const TRADEIN_STORAGE = 'mind:tradein:active';
  function persistActive(info) {
    try {
      if (info) sessionStorage.setItem(TRADEIN_STORAGE, JSON.stringify(info));
      else sessionStorage.removeItem(TRADEIN_STORAGE);
    } catch (_) { /* ignore */ }
  }
  function loadActive() {
    try { return JSON.parse(sessionStorage.getItem(TRADEIN_STORAGE) || 'null'); } catch (_) { return null; }
  }
  let active = loadActive();

  // Keep the drawer banner sticky across re-renders
  function watchDrawer() {
    const panel = document.querySelector('.cart-drawer__panel');
    if (!panel) return;
    const obs = new MutationObserver(() => {
      const foot = document.querySelector('[data-cart-drawer-foot]');
      if (active && foot && !foot.querySelector('[data-tradein-banner]')) {
        renderDrawerBanner(active);
      }
    });
    obs.observe(panel, { childList: true, subtree: true });
  }

  // ---------- Confirm: mint discount + add to cart + open drawer ----------
  // Intentionally does NOT touch PDP pricing — the drawer is the source of
  // truth for the applied total.
  async function applyToPDP() {
    const credit = state.value;
    if (!credit) return;

    if (el.confirm) {
      el.confirm.disabled = true;
      el.confirm.classList.add('is-loading');
    }

    const url = workerUrl();
    const { productId, variantId } = resolveProductInfo();

    if (!url || !variantId) {
      if (el.confirm) {
        el.confirm.disabled = false;
        el.confirm.classList.remove('is-loading');
      }
      alert('Trade-in is not fully configured for this page.');
      return;
    }

    try {
      const res = await fetch(url + '/api/create-discount', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          tradeInValue: credit,
          brand: state.brand,
          model: state.model,
          condition: state.condition,
          productId: String(productId || 0),
          variantId: String(variantId),
        }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || !data.success || !data.discountCode) {
        throw new Error(data.error || 'Could not generate trade-in discount.');
      }
      const code = data.discountCode;

      await addToCart(variantId, {
        _tradein: 'true',
        'Trade-in brand': state.brand,
        'Trade-in model': state.model || '',
        'Trade-in condition': state.condition,
        'Trade-in credit': fmt(credit),
      });

      await applyDiscountCookie(code);

      active = { code, credit, brand: state.brand, model: state.model || '', condition: state.condition };
      persistActive(active);

      if (window.MindCart && typeof window.MindCart.refresh === 'function') {
        await window.MindCart.refresh();
      }
      renderDrawerBanner(active);
      if (window.MindCart && typeof window.MindCart.open === 'function') {
        window.MindCart.open();
      }

      // Close the modal — the drawer is now the source of truth
      setTimeout(close, 150);
    } catch (err) {
      console.error('[trade-in]', err);
      alert(err.message || 'Could not apply trade-in. Please try again.');
    } finally {
      if (el.confirm) {
        el.confirm.disabled = false;
        el.confirm.classList.remove('is-loading');
      }
    }
  }

  // ---------- Wire up ----------
  function cacheRefs(overlay) {
    el = {
      overlay,
      modal: $('.ti-modal', overlay),
      closeBtn: $('#ti-close', overlay),
      brandOpts: $('#ti-brand-opts', overlay),
      modelOpts: $('#ti-model-opts', overlay),
      condOpts:  $('#ti-cond-opts', overlay),
      selBrand:  $('#ti-sel-brand', overlay),
      selModel:  $('#ti-sel-model', overlay),
      sumBrand:  $('#ti-sum-brand', overlay),
      sumModel:  $('#ti-sum-model', overlay),
      sumCond:   $('#ti-sum-cond', overlay),
      sumValue:  $('#ti-sum-value', overlay),
      priceNew:  $('#ti-price-new', overlay),
      priceWas:  $('#ti-price-was', overlay),
      terms:     $('#ti-terms', overlay),
      confirm:   $('#ti-confirm', overlay),
    };
  }

  function bind() {
    // Close
    el.closeBtn?.addEventListener('click', close);
    el.overlay.addEventListener('click', (e) => {
      if (e.target === el.overlay) close();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !el.overlay.hidden) close();
    });

    // Back buttons
    $$('[data-back]', el.modal).forEach((btn) => {
      btn.addEventListener('click', () => goToStep(parseInt(btn.dataset.back, 10)));
    });

    // Terms / confirm
    el.terms?.addEventListener('change', () => {
      el.confirm.disabled = !el.terms.checked;
    });
    el.confirm?.addEventListener('click', () => {
      applyToPDP();
    });

    // Triggers: any element with data-tradein-open, or the "Get estimate"
    // link inside the tradein-card that ships with product.html.
    document.querySelectorAll('[data-tradein-open]').forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        open();
      });
    });
  }

  // ---------- Load live config from the worker ----------
  async function loadConfig() {
    const url = workerUrl();
    if (!url) return false;
    try {
      const res = await fetch(url + '/api/config', { headers: { Accept: 'application/json' } });
      if (!res.ok) throw new Error('config ' + res.status);
      const cfg = await res.json();

      // Brands → array of strings, preserving the order from the sheet, and
      // always appending "Other" at the end if it's not already there.
      if (Array.isArray(cfg.brands) && cfg.brands.length) {
        const list = cfg.brands
          .filter((b) => (b.is_active || 'TRUE').toUpperCase() === 'TRUE')
          .map((b) => b.brand_name)
          .filter(Boolean);
        if (!list.some((b) => b.toLowerCase() === 'other')) list.push('Other');
        DATA.brands = list;
      }

      // Phones → { brand, model, base }
      if (Array.isArray(cfg.phones) && cfg.phones.length) {
        DATA.phones = cfg.phones
          .map((p) => ({
            brand: p.brand,
            model: p.model,
            base: parseFloat(p.base_trade_value) || 0,
          }))
          .filter((p) => p.brand && p.model);
      }

      // Conditions → { name, modifier, desc }
      if (Array.isArray(cfg.conditions) && cfg.conditions.length) {
        DATA.conditions = cfg.conditions
          .map((c) => ({
            name: c.condition_name,
            modifier: parseFloat(c.percentage_modifier) || 0,
            desc: c.description || '',
          }))
          .filter((c) => c.name);
      }

      // Settings → otherOffer, returnDays (basePrice stays from the page)
      if (cfg.settings && typeof cfg.settings === 'object') {
        if (cfg.settings.other_offer_amount != null) {
          DATA.settings.otherOffer = parseInt(cfg.settings.other_offer_amount, 10) || DATA.settings.otherOffer;
        }
        if (cfg.settings.return_days != null) {
          DATA.settings.returnDays = parseInt(cfg.settings.return_days, 10) || DATA.settings.returnDays;
        }
      }

      return true;
    } catch (err) {
      console.warn('[trade-in] falling back to embedded data:', err.message);
      return false;
    }
  }

  // ---------- Init ----------
  function init() {
    const overlay = buildModal();
    cacheRefs(overlay);
    bind();
    // Expose a minimal API for debugging / external triggers.
    window.MindTradeIn = Object.assign(window.MindTradeIn || {}, { open, close, state, reload: refresh });

    // Kick off config fetch + initial render. We render immediately from
    // whatever DATA we have now (possibly stale / embedded fallback), then
    // re-render after the worker responds so users never see a blank list.
    renderBrands();
    loadConfig().then((ok) => { if (ok) renderBrands(); });

    // Drawer integration — sticky banner across re-renders
    watchDrawer();
    if (active) renderDrawerBanner(active);
  }

  async function refresh() {
    const ok = await loadConfig();
    if (ok) renderBrands();
    return ok;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
